import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Combine classes with Tailwind merge
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

// Format currency
export function formatCurrency(amount: number): string {
	return new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "EUR",
	}).format(amount);
}

// Format date
export function formatDate(date: Date | string) {
	const dateObject = typeof date === "string" ? new Date(date) : date;

	return new Intl.DateTimeFormat("en-US", {
		year: "numeric",
		month: "long",
		day: "numeric",
	}).format(dateObject);
}

// Generate a random string
export function generateRandomString(length = 8) {
	const chars =
		"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	let result = "";

	for (let i = 0; i < length; i++) {
		result += chars.charAt(Math.floor(Math.random() * chars.length));
	}

	return result;
}

// Create a slug from a string
export function createSlug(str: string) {
	return str
		.toLowerCase()
		.replace(/\s+/g, "-")
		.replace(/[^\w-]+/g, "")
		.replace(/--+/g, "-")
		.trim();
}

export function getOrderStatusBadgeStyles(status: string) {
	switch (status) {
		case "COMPLETED":
			return "bg-success/10 text-success border border-success/20";
		case "PENDING":
			return "bg-warning/10 text-warning border border-warning/20";
		case "PAID":
			return "bg-info/10 text-info border border-info/20";
		case "PENDING_DELIVERY":
			return "bg-primary/10 text-primary border border-primary/20";
		case "CANCELLED":
			return "bg-error/10 text-error border border-error/20";
		default:
			return "bg-base-300/50 text-base-content/70 border border-base-300";
	}
}
